function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "onprocess_svg__a",
  x1: "50.147%",
  x2: "50.147%",
  y1: "100.155%",
  y2: "-.25%"
}, /*#__PURE__*/React.createElement("stop", {
  offset: "26%",
  stopColor: "#F69321"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "74%",
  stopColor: "#EF7700"
})));

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M15.25 4.57a6.963 6.963 0 008.472 9.084v10.982c0 1.125-.894 2.059-2.01 2.138l-.155.005H2.164a2.166 2.166 0 01-2.159-1.99L0 24.635V9.063c0-.078.026-.13.053-.182 0-.018.011-.024.02-.033l.006-.02.08-.13.026-.026v-.025l2.27-3.137a2.406 2.406 0 011.689-.933l.183-.007H15.25zM4.604 21.22H2.698a.633.633 0 00-.635.63.63.63 0 00.541.621l.094.007h1.906c.35 0 .635-.282.635-.629a.632.632 0 00-.635-.629zm1.906-2.516H2.698a.633.633 0 00-.635.629.63.63 0 00.541.622l.094.007H6.51c.35 0 .635-.282.635-.629a.633.633 0 00-.635-.629zm15.28-17.12a5.378 5.378 0 110 10.757 5.378 5.378 0 010-10.757zm-8.07 7.964h-3.694V12.3l1.847-.992 1.847.992V9.548zm7.88-5.526a.69.69 0 00-.684.597l-.006.094v3.453a.69.69 0 00.414.633l.097.034 2.244.605a.691.691 0 00.456-1.3l-.097-.034-1.733-.467V4.713a.691.691 0 00-.69-.691zm-8.67 2.637h-2.11l-.449 1.568h3.008l-.449-1.568zm-4.3 0H4.328c-.06 0-.104.015-.134.044l-.024.034-1.056 1.49H8.18l.449-1.568z",
  transform: "translate(0 -1)",
  fill: "url(#onprocess_svg__a)",
  fillRule: "nonzero"
});

function SvgOnprocess(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 26
  }, props), _ref, _ref2);
}

export default SvgOnprocess;